import { FormattedMessage } from 'react-intl'
import { useState, useEffect } from 'react'
import store from 'store2'
import API from '../../../api'

const ReviewVote = ({ review, type, iconType }) => {
  const [isActive, setActive] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [votes, setVotes] = useState(0)
  let reviewsVotes = store.get('diveSiteVotes')

  useEffect(() => {
    const amount = type === 'like' ? review.likes : review.dislikes
    setVotes(amount)
    const reviewsData = reviewsVotes && reviewsVotes[type]

    // if user is already voted
    setActive(reviewsData && reviewsData.includes(review.objectId))
  }, [])

  const handleVoting = () => {
    setDisabled(true)
    API(`dive-guide/adventure-dive-site/reviews/${review.objectId}/reactions/`)
      .post({
        [type]: !isActive ? '1' : '-1',
      })
      .then((res) => {
        if(res.status === 'success') {
          updateVotes()
        }
      })
      .finally(() => {
        setDisabled(false)
      })
  }

  const updateVotes = () => {
    if(!isActive) {
      setVotes((votes) => votes + 1)
      addVoteToStore()
    } else {
      setVotes((votes) => (votes ? votes - 1 : 0))
      removeVoteFromStore()
    }
    setActive((isActive) => !isActive)
  }

  const addVoteToStore = () => {
    try {
      reviewsVotes[type].push(review.objectId)
      store('diveSiteVotes', reviewsVotes)
    } catch (e) {
      console.error(e)
    }
  }

  const removeVoteFromStore = () => {
    try {
      reviewsVotes[type] = reviewsVotes[type].filter(
        (id) => id !== review.objectId
      )
      store('diveSiteVotes', reviewsVotes)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <button
      className={`btn-counter ${isActive ? 'active' : ''}`}
      disabled={disabled}
      onClick={handleVoting}
    >
      <i className={`font-icons icon-thumbs-${iconType}-new`} />
      <span>{`${votes}`}</span>
    </button>
  )
}

const ReviewVotes = ({ review }) => {
  return (
    <div className='voting-block'>
      <FormattedMessage
        id='reviews.was_helpful'
        defaultMessage='Was this review helpful?'
      />
      <ReviewVote review={review} type='like' iconType='up' />
      <ReviewVote review={review} type='dislike' iconType='down' />
    </div>
  )
}

export default ReviewVotes
